var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBulletedListreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6 2.26172h9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 8.01172h9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 13.7617h9"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 2.25,
    cy: 2.25,
    fill: "currentColor",
    fillRule: "nonzero",
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.25,
    cy: 8.01172,
    fill: "currentColor",
    fillRule: "nonzero",
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.25,
    cy: 13.2617,
    fill: "currentColor",
    fillRule: "nonzero",
    r: 1.25
  }))));
}
export default SvgBulletedListreact;